export const emptyTasksText = {
    NoTasks: {
        en: "No Tasks Found!",
        mr: "कोणतेही कार्य आढळले नाही!",
    },
    Message: {
        en: "There are no Tasks assigned for you at the moment.",
        mr: "सध्या तुमच्यासाठी कोणतेही काम नेमलेले नाही.",
    },
    GoBack: {
        en: "Go back",
        mr: "परत जा",
    },
};
